"use strict";
const actionTypes = require('../actionTypes');
function sessions(sessionsState = buildSessionsState(), action) {
    switch (action.type) {
        case actionTypes.LISTEN_TO_SESSIONS: {
            const listenToSessionsAction = action;
            return Object.assign({}, sessionsState, {
                sessionsRef: listenToSessionsAction.ref,
            });
        }
        case actionTypes.STOP_LISTENING_TO_SESSIONS: {
            return Object.assign({}, sessionsState, {
                sessionsRef: null,
            });
        }
        case actionTypes.LOGOUT: {
            return buildSessionsState();
        }
        case actionTypes.SESSION_ADDED: {
            const { taskId, sessionsByDate } = action;
            return Object.assign({}, sessionsState, {
                sessions: Object.assign({}, sessionsState.sessions, { [taskId]: sessionsByDate }),
            });
        }
        case actionTypes.SESSION_CHANGED: {
            const { taskId, sessionsByDate } = action;
            return Object.assign({}, sessionsState, {
                sessions: Object.assign({}, sessionsState.sessions, { [taskId]: sessionsByDate }),
            });
        }
        default:
            return sessionsState;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = sessions;
const buildSessionsState = (partialState = {}) => Object.assign({
    sessions: null,
    sessionsRef: null,
    sessionsListener: null
}, partialState);



/** WEBPACK FOOTER **
 ** ./src/reducers/sessions.ts
 **/